import api from './api';
import { 
  DashboardStats,
  User,
  UserCreate,
  UserUpdate,
  UserListParams,
  Job,
  AdminJobListParams,
  JobApplication,
  ApplicationListParams,
  ApplicationStatusUpdate
} from '@/types';

class AdminService {
  // Dashboard
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await api.get<DashboardStats>('/api/admin/dashboard');
    return response.data;
  }

  // User Management
  async getUsers(params: UserListParams = {}): Promise<User[]> {
    const response = await api.get<User[]>('/api/admin/users', { params });
    return response.data;
  }

  async createUser(userData: UserCreate): Promise<User> {
    const response = await api.post<User>('/api/admin/users', userData);
    return response.data;
  }

  async updateUser(id: number, userData: UserUpdate): Promise<User> {
    const response = await api.put<User>(`/api/admin/users/${id}`, userData);
    return response.data;
  }

  async deleteUser(id: number): Promise<{ message: string }> {
    const response = await api.delete(`/api/admin/users/${id}`);
    return response.data;
  }

  // Job Management
  async getJobs(params: AdminJobListParams = {}): Promise<Job[]> {
    const response = await api.get<Job[]>('/api/admin/jobs', { params });
    return response.data;
  }

  // Application Management
  async getApplications(params: ApplicationListParams = {}): Promise<JobApplication[]> {
    const response = await api.get<JobApplication[]>('/api/admin/applications', { params });
    return response.data;
  }

  async getApplication(id: number): Promise<JobApplication> {
    const response = await api.get<JobApplication>(`/api/admin/applications/${id}`);
    return response.data;
  }

  async updateApplicationStatus(id: number, statusUpdate: ApplicationStatusUpdate): Promise<JobApplication> {
    const response = await api.put<JobApplication>(`/api/admin/applications/${id}/status`, statusUpdate);
    return response.data;
  }

  async deleteApplication(id: number): Promise<{ message: string }> {
    const response = await api.delete(`/api/admin/applications/${id}`);
    return response.data;
  }
}

export const adminService = new AdminService();